import { connect } from 'react-redux';

import { PAGE } from 'dpl/constants/query_params';
import { resetParams, pushParams } from 'dpl/actions/query_params';

export default function withPagination(options) {
  function mapStateToProps({ queryParams }) {
    const { itemsPerPage } = options;
    const currentPage = queryParams[PAGE];

    return {
      itemsPerPage,
      currentPage: currentPage ? Number(currentPage) : 1
    };
  }

  return connect(mapStateToProps, {
    setPage: pageNumber =>
      pushParams({
        [PAGE]: pageNumber
      }),
    resetPage: resetParams(PAGE)
  });
}
